module.exports = __webpack_public_path__ + "img/coins-yellow.58ab07c3.svg";